import React from 'react'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import { PatternFormat } from 'react-number-format'
import HHTextField from './HHTextField'

const HHPhoneField = ({
  value = '',
  phoneExtension = '',
  displayType = 'input',
  defaultValue = '--',
  formatResult = false,
  onValueChange = noop,
  ...rest
}) => {
  if (displayType === 'text' && !value) {
    return defaultValue
  }

  const phone = (
    <PatternFormat
      value={value}
      displayType={displayType}
      placeholder="(201) 555-0123"
      format="(###) ###-####"
      autoComplete="off"
      customInput={HHTextField}
      onValueChange={event => {
        const { value: newValue, formattedValue } = event
        onValueChange(formatResult ? formattedValue : newValue)
      }}
      {...rest}
    />
  )

  const trimmedExtension = (phoneExtension || '').trim()
  if (displayType === 'text' && trimmedExtension) {
    return (
      <>
        {phone}
        {` Ext. ${trimmedExtension}`}
      </>
    )
  }

  return phone
}

HHPhoneField.propTypes = {
  value: PropTypes.string,
  phoneExtension: PropTypes.string,
  displayType: PropTypes.string,
  defaultValue: PropTypes.string,
  formatResult: PropTypes.bool,
  onValueChange: PropTypes.func,
}

export default HHPhoneField
